
const datesSortData = {
  placeholder: 'Day, Month, Year',
  list: [
    {
      label: 'Low to high',
      order: 'low_high'
    },
    {
      label: 'High to low',
      order: 'high_low'
    },
    {
      label: 'Collection',
      order: 'collection'
    },
    {
      label: 'Rarity',
      order: 'rarity'
    }
  ],
  buttons: ['Buy Packs', 'Buy Cards']
}

const categoriesSortData = {
  placeholder: 'Athlete, Entertainer, Politician, Business Leader, Infamous',
  list: [
    {
      label: 'A-Z',
      order: 'a_z'
    },
    {
      label: 'Z-A',
      order: 'z_a'
    },
    {
      label: 'Collection',
      order: 'collection'
    },
    {
      label: 'Rarity',
      order: 'rarity'
    }
  ],
  buttons: ['Buy Packs', 'Buy Cards']
}

const identitiesSortData = {
  placeholder: 'Name',
  list: [
    {
      label: 'A-Z',
      order: 'a_z'
    },
    {
      label: 'Z-A',
      order: 'z_a'
    },
    {
      label: 'Collection',
      order: 'collection'
    },
    {
      label: 'Rarity',
      order: 'rarity'
    }
  ],
  buttons: ['Craft Identity']
}


const eventsSortData = {
  placeholder: 'Event name',
  list: [
    {
      label: 'A-Z',
      order: 'a_z'
    },
    {
      label: 'Z-A',
      order: 'z_a'
    },
    {
      label: 'Collection',
      order: 'collection'
    },
    {
      label: 'Rarity',
      order: 'rarity'
    }
  ],
  buttons: ['Buy Packs', 'Buy Cards']
}

const triggersSortData = {
  placeholder: 'Win, Lose, Tie',
  list: [
    {
      label: 'A-Z',
      order: 'a_z'
    },
    {
      label: 'Z-A',
      order: 'z_a'
    },
    {
      label: 'Collection',
      order: 'collection'
    },
    {
      label: 'Rarity',
      order: 'rarity'
    }
  ],
  buttons: ['Buy Packs', 'Buy Cards']
}

const prizesSortData = {
  placeholder: 'Value',
  list: [
    {
      label: 'Ascending',
      order: 'ascending'
    },
    {
      label: 'Descending',
      order: 'descending'
    },
    {
      label: 'Collection',
      order: 'collection'
    },
    {
      label: 'Rarity',
      order: 'rarity'
    }
  ],
  buttons: ['Buy Packs', 'Buy Cards']
}

const cardPacksSortData = {
  placeholder: 'Value',
  list: [
    {
      label: 'A-Z',
      order: 'a_z'
    },
    {
      label: 'Z-A',
      order: 'z_a'
    },
    {
      label: 'Tier',
      order: 'tier'
    },
    {
      label: 'Collection',
      order: 'collection'
    },
  ],
  buttons: ['Buy Packs']
}

const predictionsSortData = {
  placeholder: 'Date, Identity, Event, Trigger',
  list: [
    {
      label: 'A-Z',
      order: 'a_z'
    },
    {
      label: 'Z-A',
      order: 'z_a'
    },
    {
      label: 'Collection',
      order: 'collection'
    },
    {
      label: 'Rarity',
      order: 'rarity'
    }
  ],
  buttons: ['Craft Predicition']
}

const marketplaceSortDataCards = {
  placeholder: 'Name, Category, Event',
  list: [
    {
      label: 'A-Z',
      order: 'a_z'
    },
    {
      label: 'Z-A',
      order: 'z_a'
    },
    {
      label: 'Price Low to high',
      order: 'low_high'
    },
    {
      label: 'Price High to low',
      order: 'high_low'
    },
    {
      label: 'Rarity',
      order: 'rarity'
    },
  ],
  buttons: ['Sell cards']
}

const marketplaceSortDataCardPacks = {
  placeholder: 'Name, Category, Event',
  list: [
    {
      label: 'A-Z',
      order: 'a_z'
    },
    {
      label: 'Z-A',
      order: 'z_a'
    },
    {
      label: 'Price Low to high',
      order: 'low_high'
    },
    {
      label: 'Price High to low',
      order: 'high_low'
    },
    {
      label: 'Tier',
      order: 'tier'
    },
  ],
  buttons: ['Sell cards']
}

export const getSortList = (pathname) => {
  if (pathname.includes('/dates')) {
    return datesSortData;
  } else if (pathname.includes('/categories')) {
    return categoriesSortData;
  } else if (pathname.includes('/identities')) {
    return identitiesSortData;
  } else if (pathname.includes('/events')) {
    return eventsSortData;
  } else if (pathname.includes('/triggers')) {
    return triggersSortData;
  } else if (pathname.includes('/prizes')) {
    return prizesSortData;
  } else if (pathname.includes('/predictions')) {
    return predictionsSortData;
  } else if (pathname.includes('inventory/card-packs') || pathname.includes('inventory/card-pack-open')) {
    return cardPacksSortData;
  } else if (pathname.includes('/marketplace/cards') || pathname.includes('/tutorial/marketplace')) {
    return marketplaceSortDataCards
  } else if (pathname.includes('/marketplace/card-packs')) {
    return marketplaceSortDataCardPacks
  }
}
